import {decodeConsentString} from 'consent-string';
import {CMP_ID, PURPOSE_CONTENT, PURPOSE_ADS, CONSENT_COOKIE_NAME} from '../constants';
import {setCookie, getCookie, existsCookie, resaveCookie} from './cookie';
import {logger} from './logger';

/**
 * Returns true if "euconsent" already exists in Profile.
 * @param {Object} data
 * @return {boolean}
 */
export const hasEuconsentAlready = data => data && data.euconsent && data.euconsent.encodedCookie;

/**
 * Returns true if consent already exists in Profile.
 * @param {Object} data
 * @return {boolean}
 */
export const hasConsentAlready = data =>
  data && data.consents && (typeof data.consents[PURPOSE_CONTENT] === 'boolean' || typeof data.consents[PURPOSE_ADS] === 'boolean');

/**
 * Sets consent cookie.
 * @param {string} consent
 */
export const setConsentCookie = consent => setCookie(consent, CONSENT_COOKIE_NAME);

/**
 * Gets consent cookie.
 * @returns {string}
 */
export const getConsentCookie = () => getCookie(CONSENT_COOKIE_NAME);

/**
 * Check if consent cookie exists.
 * @return {boolean}
 */
export const existsConsentCookie = () => existsCookie(CONSENT_COOKIE_NAME);

/**
 * Resaves consent cookie in Safari if exists.
 */
export const resaveConsentCookie = () => resaveCookie(CONSENT_COOKIE_NAME);

/**
 * Check if cookie string is made by Seznam.
 * @param {string} euconsent string
 * @return {boolean}
 */
export const isForeignEuconsent = () => {
  const {cmpId} = decodeConsentString(getCookie(CONSENT_COOKIE_NAME));
  return cmpId !== CMP_ID;
};

/**
 * Saves encoded cookie into browser.
 * @param {string} euconsent
 */
export const saveSettingsToBrowser = euconsent => {
  logger(800, 'Saving euconsent cookie into browser:', euconsent);
  setConsentCookie(euconsent);
};
